import * as Filestack from 'filestack-js';
import _ from 'underscore';

import LogRocket from '@helpers/logRocket';


const snakeCase = (string) => string.replace(/([A-Z])/g, "_$1").toLowerCase();

const filteredFiles = (uploadedFiles) => {
  let files = _.filter(uploadedFiles, (file) => (file.filename.charAt(0) !== "." && !file.filename.match(/thumbs\.db|\.jsx?$/i) && !file.mimetype.match(/application\/javascript|text\/javascript|application\/x-actionscript|text\/x-actionscript|application\/ecmascript|text\/ecmascript/i)));
  // sort alphabetically for upload
  files = _.sortBy(files, 'filename');
  files = _.sortBy(files, 'folder_path');
  if (uploadedFiles.length !== files.length) {
    const restricted_files_count = uploadedFiles.length - files.length;
    window.swal({
      title: `${restricted_files_count} ${bfTranslate('Restricted File(s) Detected!')}`,
      text: bfTranslate("We reject certain filetypes, including HTML and Javascript"),
      type: "error"
    });
  }
  return files;
};

const structureFiles = (files) => files.map((file) => {
  /* eslint-disable no-param-reassign */
  _.map(file, (value, key) => {
    delete file[key];
    // This function scrubs the object's properties to match what we expect server side.
    // It renames keys and stuff. If you change this, you'll likely break something important.
    if (key === "originalPath") { key = "folder_path"; }
    if (key === "uploadId") {
      file.data = { filepicker_upload_id: value };
    } else if (key === "source") {
      file.data = { filepicker_client: value };
    } else if (key === "status" || key === "originalFile") {
      // don't pass these along
    } else if (key === "handle") {
      // Let's combine 'filestack' with the actual value so we can differentiate sources visually.
      // We'll also make sure to do lookups with the word 'filestack'
      file.external_id = `filestack|${value}`;
    } else {
      file[snakeCase(key)] = value;
    }
  });
  return file;
});

const addFiles = (filestackResponse, onUpload) => {
  const files = filteredFiles(filestackResponse.filesUploaded);
  const structuredFiles = structureFiles(files);
  return onUpload(structuredFiles);
};

const initDefaultPicker = (onUpload, options) => {
  const filestackOptions = { security: BFG.filestack.signature_object, cname: BFG.filestack.cname };
  const filestack = Filestack.init(BFG.filestack.API_KEY, filestackOptions);

  const handleError = (file, error) => {
    if (error && error.message.indexOf('cancel') === -1) {
      LogRocket.captureMessage('Error Uploading File to Filestack', {
        tags: { file, error },
        extra: { file, error }
      });
    }
  };

  const defaultOptions = {
    onUploadDone: (filestackResponse) => addFiles(filestackResponse, onUpload),
    onFileUploadFailed: handleError,
    disableThumbnails: true,
    maxFiles: 3000,
    fromSources: ['local_file_system', 'googledrive', 'dropbox', 'box', 'url'],
    globalDropZone: false,
    uploadConfig: {
      // default Filestack timeout for FII (intelligent ingestion) is only 1 minute
      timeout: 180000,
      intelligent: 'fallback'
    },
    storeTo: {
      location: 's3'
    }
  };

  const storageOptions = () => {
    if (!BFG.context.uses_gcs && BFG.context.storageRegion && BFG.context.storageRegion !== BFG.context.defaultStorageRegion) {
      return {
        storeTo: {
          location: 's3',
          container: `bf-filestack-prod-${BFG.context.storageRegion}`,
          region: BFG.context.storageRegion,
          path: '/'
        }
      };
    }
    return {};
  };

  const completeOptions = {
    ...defaultOptions,
    ...storageOptions(),
    ...options
  };

  return filestack.picker(completeOptions);
};

export default initDefaultPicker;
